<ng-container [ngSwitch]="status">
  <mat-chip-list>
    <mat-chip size="sm" class="downChipStats" *ngSwitchCase="CAMERA_STATUS.Down">
      <div class="downChipLabel">
        <span>Down</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="upChipStats" *ngSwitchCase="CAMERA_STATUS.Up">
      <div class="upChipLabel">
        <span>Up</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="warningChipStats" *ngSwitchCase="CAMERA_STATUS.Pending">
      <div class="pendingChipLabel">
        <span>Pending</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="unconfiguredChipStats" *ngSwitchCase="CAMERA_STATUS.Unconfigured">
      <div class="unconfiguredChipLabel">
        <span>Unconfigured</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="unmanagedChipStats" *ngSwitchCase="CAMERA_STATUS.Unmanaged">
      <div class="unmanagedChipLabel">
        <span>Unmanaged</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-container>
